import { fetchWithAuth } from '../helpers';

const getAll = async () => {
  const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/exams`, {
    method: 'GET',
    headers: { "ngrok-skip-browser-warning": "69420" },
  });
  return handleResponse(response);
};

const getAllPaginated = async (params: { 
  page: number; 
  limit: number; 
  search?: string; 
  status?: string;
  difficulty?: string;
  created_by?: string;
}) => {
  const queryParams = new URLSearchParams({
    page: params.page.toString(),
    limit: params.limit.toString(),
  });

  if (params.search) queryParams.append('search', params.search);
  if (params.status) queryParams.append('status', params.status);
  if (params.difficulty) queryParams.append('difficulty', params.difficulty);
  if (params.created_by) queryParams.append('created_by', params.created_by);

  const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/exams?${queryParams.toString()}`, {
    method: 'GET',
    headers: { "ngrok-skip-browser-warning": "69420" },
  });
  return handleResponse(response);
};

const getById = async (id: number) => {
  const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/exams/${id}`, {
    method: 'GET',
    headers: { "ngrok-skip-browser-warning": "69420" },
  });
  return handleResponse(response);
};

const getByShareLink = async (shareLink: string) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/exams/public/${shareLink}`, {
    method: 'GET',
    headers: { "ngrok-skip-browser-warning": "69420" },
  });
  return handleResponse(response);
};

const submitByShareLink = async (shareLink: string, payload: any) => {
  const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/exams/public/${shareLink}/submit`, {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json',
      "ngrok-skip-browser-warning": "69420" 
    },
    body: JSON.stringify(payload),
  });
  return handleResponse(response);
};

const getSubmissions = async (examId: number) => {
  const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/exams/${examId}/submissions`, {
    method: 'GET',
    headers: { "ngrok-skip-browser-warning": "69420" },
  });
  return handleResponse(response);
};

const create = (exam: any) => {
  return fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/exams`, {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json',
      "ngrok-skip-browser-warning": "69420" 
    },
    body: JSON.stringify(exam)
  })
    .then(handleResponse);
};

const update = (exam: any) => {
  return fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/exams/${exam.id}`, {
    method: 'PUT',
    headers: { 
      'Content-Type': 'application/json',
      "ngrok-skip-browser-warning": "69420" 
    },
    body: JSON.stringify(exam)
  })
    .then(handleResponse);
};

const remove = (id: number) => {
  return fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/exams/${id}`, {
    method: 'DELETE',
    headers: { "ngrok-skip-browser-warning": "69420" }
  })
    .then(handleResponse);
};

const addQuestions = (examId: number, data: { method: 'manual' | 'filter' | 'auto'; question_ids?: number[]; filters?: any; count?: number }) => {
  return fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/exams/${examId}/questions`, {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json',
      "ngrok-skip-browser-warning": "69420" 
    },
    body: JSON.stringify(data)
  })
    .then(handleResponse);
};

const removeQuestion = (examId: number, questionId: number) => {
  return fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/exams/${examId}/questions/${questionId}`, {
    method: 'DELETE',
    headers: { "ngrok-skip-browser-warning": "69420" }
  })
    .then(handleResponse);
};

const updateQuestion = (examId: number, questionId: number, data: { order_index?: number; score?: number }) => {
  return fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/exams/${examId}/questions/${questionId}`, {
    method: 'PUT',
    headers: { 
      'Content-Type': 'application/json',
      "ngrok-skip-browser-warning": "69420" 
    },
    body: JSON.stringify(data)
  })
    .then(handleResponse);
};

const duplicate = (examId: number, title?: string) => {
  return fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/exams/${examId}/duplicate`, {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json',
      "ngrok-skip-browser-warning": "69420" 
    },
    body: JSON.stringify({ title })
  })
    .then(handleResponse);
};

function handleResponse(response: any) {
  return response.text().then((text: string) => {
    let data;
    try {
      data = text && JSON.parse(text);
    } catch (error) {
      data = text;
    }

    if (!response.ok) {
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}

const getStudentSubmissions = async (studentId: number) => {
  const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/exams/student/${studentId}/submissions`, {
    method: 'GET',
    headers: { "ngrok-skip-browser-warning": "69420" },
  });
  return handleResponse(response);
};

const getAllSubmissions = async () => {
  const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/exams/submissions/all`, {
    method: 'GET',
    headers: { "ngrok-skip-browser-warning": "69420" },
  });
  return handleResponse(response);
};

export const examService = {
  getAll,
  getAllPaginated,
  getById,
  create,
  update,
  remove,
  addQuestions,
  removeQuestion,
  updateQuestion,
  duplicate,
  getByShareLink,
  submitByShareLink,
  getSubmissions,
  getStudentSubmissions,
  getAllSubmissions,
};
